
export default function initHeaderAccueil() {
    const $blocksHeaderAccueil = document.querySelectorAll<HTMLElement>('.block-header-accueil');
    $blocksHeaderAccueil.forEach($container => {
        new BlockHeaderAccueil($container);
    });
}

/**
 * @param {HTMLElement} $el           HTML Element Block nos offres
 */
class BlockHeaderAccueil {
    private $el: HTMLElement | null | undefined;
    private $slides: HTMLElement[];
    private $slidesButtons: HTMLElement[];
    private $buttonPrev: HTMLElement | null;
    private $buttonNext: HTMLElement | null;
    private timerAutoSwitch: number | null;
    private timerExpandProgressBar: number | null;
    private tabButtonActive : HTMLElement | null | undefined;
    private progressBarActive : HTMLElement | null | undefined;
    private totalDuration: number;
    private interval: number;
    private currentWidth: number;
    
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slides = Array.from($el?.querySelectorAll('.js-slide'));
        this.$slidesButtons = Array.from($el?.querySelectorAll('.js-slider-switch-item'));
        this.$buttonPrev = $el.querySelector('.button-prev');
        this.$buttonNext = $el.querySelector('.button-next');
        this.timerAutoSwitch = null;
        this.timerExpandProgressBar = null;
        this.tabButtonActive = null;
        this.progressBarActive = null;
        this.totalDuration = 8000;
        this.interval = this.totalDuration / 100;
        this.currentWidth = 0;

        this.init();
    }

    private init() : void {
        this.desktopSlideHandler();
        this.initAutoSwitchHeaderAccueil();
        this.setupNavigationButtons();
    }

    /**
     * Initialise les onglets en desktop
     */
    private desktopSlideHandler() : void {
        this.$slidesButtons?.forEach((button, index) => {
            button.addEventListener('click', ()=> {
                if (!button.classList.contains('active')) {
                    this.$slidesButtons.forEach(btn => btn.classList.remove('active'));
                    button.classList.add('active');
                    this.$slides.forEach((slide, slideIndex) => {
                        slide.classList.toggle('active', slideIndex === index);
                    });
                    this.resetProgressBars();
                    this.startAutoSwitchHeaderAccueil();
                }
            })
        })
    }

    /**
     * Gestion des boutons de navigation prev et next
     */
    private setupNavigationButtons(): void {
        if (this.$buttonNext) {
            this.$buttonNext.addEventListener('click', this.nextSlide.bind(this));
        }
        if (this.$buttonPrev) {
            this.$buttonPrev.addEventListener('click', this.prevSlide.bind(this));
        }
    }

    private nextSlide(): void {
        const activeIndex = this.$slidesButtons.findIndex(button => button.classList.contains('active'));
        const nextIndex = (activeIndex + 1) % this.$slidesButtons.length;
        this.setActiveSlide(nextIndex);
        this.startAutoSwitchHeaderAccueil();
    }

    private prevSlide(): void {
        const activeIndex = this.$slidesButtons.findIndex(button => button.classList.contains('active'));
        const prevIndex = (activeIndex - 1 + this.$slidesButtons.length) % this.$slidesButtons.length;
        this.setActiveSlide(prevIndex);
        this.startAutoSwitchHeaderAccueil();
    }

    private setActiveSlide(index: number): void {
        this.$slidesButtons.forEach(btn => btn.classList.remove('active'));
        this.$slides.forEach(slide => slide.classList.remove('active'));
        this.$slidesButtons[index].classList.add('active');
        this.$slides[index].classList.add('active');
        this.resetProgressBars();
    }

    /**
     * Initialise l'oberserver pour lancer l'autoSwitch 
     */
    private initAutoSwitchHeaderAccueil() : void {
        const observer = new IntersectionObserver(this.onIntersection.bind(this));
        observer.observe(this.$el);
    }

    private onIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.startAutoSwitchHeaderAccueil();
            } else if (this.timerAutoSwitch) {
                clearTimeout(this.timerAutoSwitch);
                this.timerAutoSwitch = null;
            }
        });
    }

    /**
     * start Autoswitch
     */
    private startAutoSwitchHeaderAccueil() : void {
        this.clearTimers();

        const activeIndex = this.$slidesButtons.findIndex(button => button.classList.contains('active'));
        const positionNextActiveTab = (activeIndex + 1) % this.$slidesButtons.length;

        this.tabButtonActive = this.$slidesButtons[activeIndex];
        this.progressBarActive = this.tabButtonActive.querySelector('.slider-swith-item-progress') as HTMLElement;
        this.currentWidth = 2;
        this.expandProgressBar();

        this.timerAutoSwitch = window.setTimeout(() => {
            if (this.progressBarActive) {
                this.progressBarActive.style.width = '0';
            }
            this.$slidesButtons[positionNextActiveTab].click();
            this.startAutoSwitchHeaderAccueil();
        }, this.totalDuration);
    }

    private expandProgressBar() {
        this.currentWidth++;
        if (this.currentWidth >= 100) {
            this.progressBarActive.style.width = "100%";
            return;
        }
        this.progressBarActive.style.width = (this.currentWidth) + "%";
        this.timerExpandProgressBar = setTimeout(this.expandProgressBar.bind(this), this.interval);
    }

    private resetProgressBars(): void {
        this.$slidesButtons.forEach(button => {
            const progressBar = button.querySelector('.slider-swith-item-progress') as HTMLElement;
            if (progressBar) {
                progressBar.style.width = '0';
            }
        });
    }

    private clearTimers() {
        if (this.timerAutoSwitch) {
            clearTimeout(this.timerAutoSwitch);
            this.timerAutoSwitch = null;
        }
        if (this.timerExpandProgressBar) {
            clearTimeout(this.timerExpandProgressBar);
            this.timerExpandProgressBar = null;
        }
    }
}
